import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';

type Args = {
  showEntered: boolean;
  showArmed: boolean;
  showDeactivated: boolean;
};
type Callback = (tradePlanId: string) => boolean;

export function filterTradePlansCallback({
  showEntered,
  showArmed,
  showDeactivated,
}: Args): Callback {
  return (tradePlanId: string) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    if (!showEntered && tradePlan.inPosition) return false;
    if (
      !showArmed &&
      !tradePlan.inPosition &&
      !tradePlan.restartSettings.deactivated
    )
      return false;
    if (!showDeactivated && tradePlan.restartSettings.deactivated) return false;
    return true;
  };
}
